import { render, staticRenderFns } from "./CorrectImagesMatchPicker.vue?vue&type=template&id=79cd6712&scoped=true&"
import script from "./CorrectImagesMatchPicker.vue?vue&type=script&lang=ts&"
export * from "./CorrectImagesMatchPicker.vue?vue&type=script&lang=ts&"
import style0 from "./CorrectImagesMatchPicker.vue?vue&type=style&index=0&id=79cd6712&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79cd6712",
  null
  
)

export default component.exports